import { HttpClient } from './serviceBase';
import { utils } from '../utils/utils'


class OrderService {
    Search = async (filters, config = null) => {
        const queryString = utils.GetQueryStringsFromObject(filters);
        return await HttpClient.Get(`/api/orders/search?${queryString}`, config);
    };

    Get = async (orderId) =>
        await HttpClient.Get(`/api/orders/${orderId}`);

    Create = async (order) =>
        await HttpClient.Post(`/api/orders`, order);

    Update = async (order) =>
        await HttpClient.Put(`/api/orders/${order.id}`, order);

    Delete = async (orderId) =>
        await HttpClient.Delete(`/api/orders/${orderId}`);

    GetCard = async (orderId, binNumber, branchId, withDisablePlans) => 
        await HttpClient.Get(`/api/orders/${orderId}/card/${binNumber}?branchId=${branchId}&withDisablePlans=${withDisablePlans}`);
       
    GetCardPlans = async (orderId, bankId, cardId, branchId) =>
        await HttpClient.Get(`/api/orders/${orderId}/card/${cardId}/plans/${bankId}?branchId=${branchId}`);

    GetCardPlansWithAmount = async (orderId, bankId, cardId, amount, branchId) =>
        await HttpClient.Get(`/api/orders/${orderId}/card/${cardId}/plans/${bankId}?amount=${amount}&branchId=${branchId}`);

    GetCardWithAmount = async (orderId, amount, binNumber, branchId) => 
        await HttpClient.Get(`/api/orders/${orderId}/card/${binNumber}?amount=${amount}&branchId=${branchId}`);
       
    Invoice = async (orderId, manualInvoiceData = null, refundItems = null) =>
        await HttpClient.Post(`/api/orders/${orderId}/invoice`, { orderId, manualInvoiceData, refundItems });

    CreateChange = async (orderId, order) =>
        await HttpClient.Post(`/api/orders/${orderId}/change`, order);

    CreateItemsChange = async (orderId, items) =>
        await HttpClient.Post(
            `/api/orders/${orderId}/changeorder`,
            {
                orderId,
                changeItems: items
            });

    VoidOrder = async (orderId, extraData, warehouseId, billingCode) => 
        await HttpClient.Post(`/api/orders/${orderId}/void`, {
            orderId,
            warehouseId,
            billingCode,
            manualInvoiceData: extraData?.manualInvoiceData,
            refundCupons: extraData?.refundCupons,
            refundItems: extraData?.refundItems
        });

    Refund = async (orderId, model, warehouseId, billingCode) =>
        await HttpClient.Post(`/api/orders/${orderId}/refund`, {
            orderId,
            warehouseId,
            billingCode,
            refundItems: model.refundItems,
            manualInvoiceData: model.manualInvoiceData,
            refundCupons: model.refundCupons
        });

    RetryOperation = async (orderId) =>
        await HttpClient.Post(`/api/orders/${orderId}/operations/retry`);

    PaymentsCancelation = async (orderId) =>
        await HttpClient.Post(`/api/orders/${orderId}/cancelation`);

    CancelOperation = async (orderId) =>
        await HttpClient.Post(`/api/orders/${orderId}/operations/cancel`);

    UpdateCustomer = async (orderId, customer) =>
        await HttpClient.Post(`/api/orders/${orderId}/update-customer`, customer)

    GetTicket = async (voucherId, type) =>
        await HttpClient.GetText(`/api/billing/${voucherId}/ticket?type=${type}`);

    GetChangeTicket = async (voucherId, items) =>
        await HttpClient.GetTextWithBody(`/api/billing/${voucherId}/ticket/change`, items);

    PrintTicket = async (voucherId, type, printerId, isTaxFree) =>
        await HttpClient.Post(`/api/billing/${voucherId}/print/${printerId}/ticket?type=${type}&istaxfree=${isTaxFree}`);

    PrintChangeTicket = async (voucherId, printerId, items, quantity = 1) =>
        await HttpClient.Post(`/api/billing/${voucherId}/print/${printerId}/ticket/change?quantity=${quantity}`, items);

    PrintAllChangeTicket = async (voucherId, printerId, items) =>
        await HttpClient.Post(`/api/billing/${voucherId}/print/${printerId}/ticket/all-change`, items);

    SendEmailTicket = async (data) =>
        await HttpClient.Post(`/api/billing/send-mail/ticket`, data)

    SendEmailChangeTicket = async (data) =>
        await HttpClient.Post(`/api/billing/send-mail/ticket/change`, data)
}

export default new OrderService();